module.exports = __webpack_public_path__ + "static/media/icon_watch.9e64d646.svg";